import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const DeleteInvoiceDialog = ({ deleteFor, onClose, onSubmit }) => (
  <AlertDialog open={!!deleteFor} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent data-testid="delete-invoice-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Permanently delete this invoice?</AlertDialogTitle>
        <AlertDialogDescription>
          This will permanently remove order {deleteFor?.order_no} ({deleteFor?.invoice_no || "no invoice issued"}) from all records and reports.
          This cannot be undone. For normal cancellations, use &quot;Cancel Invoice&quot; instead — it keeps the record for your books.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <AlertDialogAction data-testid="delete-invoice-confirm" onClick={onSubmit} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
          Permanently Delete
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
